<tui-root #rootResize appAmplitude appGtm waResizeObserver>
  <tui-loader class="root-loader" [showLoader]="loading$ | async" [overlay]="true" size="xxl">
    <router-outlet></router-outlet>
  </tui-loader>
</tui-root>
